import connection from './config'
import store from '../store'

/**
 * 获取kid列表
 * @param page 页数
 * @param size 每页显示个数
 */
export const kidLists = () => {
  if (store.state.isXTC == 1) { // eslint-disable-line
    return connection.get(`/api/v1/member/kid/xtc/list`)
  } else {
    return connection.get(`/api/v1/member/kid/list`)
  }
}

/**
 * 获取当前kid
 */
export const currentKid = () => {
  return connection.get(`/api/v1/member/kid/current`)
}

/**
 * @param param
 * @returns {*}
 */
export const editKid = (params) => {
  if (store.state.isXTC == 1) { // eslint-disable-line
    return connection.post(`/api/v1/member/kid/xtc/update${params.id ? '/' + params.id : ''}?name=${params.name}&sex=${params.sex}&grade=${params.grade}&semester=${params.semester}`)
  } else {
    return connection.post(`/api/v1/member/kid${params.id ? '/' + params.id : ''}?name=${params.name}&sex=${params.sex}&grade=${params.grade}&semester=${params.semester}`)
  }
}

/**
 * 获取当前设备列表
 */
export const getDevices = (page = 1, size = 10) => {
  return connection.get(`/api/v1/member/device?page=${page}&size=${size}`)
}
